<template>
  <v-card>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="guardar()"
    >
      <v-card-title>
        DUPLICACIÓN POR CONSUMO DE AGUA
        <v-spacer/>
        <v-btn
            icon
            @click="$emit('close')"
        >
          X
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="cuenta"
                label="Cuenta *"
                outlined
                autofocus
                maxlength="7"
                :rules="[v => !!v || 'Cuenta es requerida']"
                @keypress="patterns.onlyNumber($event)"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="nfac"
                label="Número de factura *"
                outlined
                maxlength="5"
                :rules="[v => !!v || 'Número de factura es requerida']"
                @keypress="patterns.onlyNumber($event)"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
                label="Motivo *"
                v-model="motivo"
                :items="motivos"
                item-value="id"
                item-text="descripcion"
                outlined
                return-object
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="duplicacionStore.fechaHora"
                label="Fecha *"
                outlined
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-footer>
        <v-spacer/>
        <v-btn
            color="primary"
            type="submit"
            :loading="loading"
        >
          Duplicar factura
        </v-btn>
      </v-footer>
    </v-form>
    <div id="myElement">
    </div>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {duplicacionStore} from "@/store/duplicacionStore";
import {Duplicacion} from "@/models/Duplicacion";
import {Pattern} from "@/addons/Pattern";
import {DuplicacionService} from "@/services/DuplicacionService";
import {recaudacionStore} from "@/store/recaudacionStore";
import {PrintConsumo} from "@/addons/PrintConsumo";

@Component({
  name: "DuplicacionConsumoAgua"
})

export default class DuplicacionConsumoAgua extends Vue {
  private patterns = Pattern;
  private duplicacionStore = duplicacionStore();
  private duplicacionService = DuplicacionService.getInstance();
  private recaudacionStore = recaudacionStore();

  cuenta = null;
  nfac = null;
  motivo = {
    "cod": "1",
    "descripcion": "POR DESPERFECTO"
  };

  valid = true;
  $refs!: {
    form: HTMLFormElement
  };

  get loading(): boolean {
    return this.duplicacionStore.loading;
  }

  get duplicacion(): Duplicacion {
    return this.duplicacionStore.duplicacion;
  }

  get motivos(): any[] {
    return this.duplicacionStore.motivos;
  }

  mounted() {
    this.duplicacionService.getMotivosDuplicacion();
  }

  guardar() {
    if (!this.$refs.form.validate()) {
      return;
    }

    const data = {
      cuenta: this.cuenta,
      nfac: this.nfac,
      motivo: this.motivo,
      fechaHora: this.duplicacionStore.fechaHora
    }
    this.duplicacionService.duplicacionConsumo(data).then((res: any) => {
      if (res.success) {
        this.resetFields();
        this.imprimir(res);
      }
    });
  }

  private imprimir(res: any) {
    const printConsumo = new PrintConsumo();
    printConsumo.imprimir(res.factura, res.cliente, true);
  }

  private resetFields() {
    this.cuenta = null;
    this.nfac = null;
    this.motivo = {
      "cod": "1",
      "descripcion": "POR DESPERFECTO"
    };
  }
}
</script>

<style scoped>

</style>